@let isUpdating = functionalUsagePlugin.selectors.isUpdating.asSignal();

@if (isUpdating) {
  @let isLoading = functionalUsagePlugin.selectors.isLoading.asSignal();
  @let canSave = canSaveSg();
  @let functionalizations =
    functionalUsagePlugin.selectors.editingFunctionalUsage.asSignal();

  <atn-ds-centered-overlay type="wide">
    <div class="atn-space-cluster-functional-usage-modal">
      <atn-ds-widget title="Update Functional Usage">
        <div actions>
          <i
            class="atn-icon atn-close atn-red"
            (click)="cancelClickHandler()"
          ></i>
        </div>

        <div class="atn-space-cluster-functional-usage-modal__content">
          <div class="atn-space-cluster-functional-usage-modal__field">
            <span><b>Allocations</b></span>
            <atn-space-modal-functionalizations
              [functionalizations]="functionalizations ?? []"
              (functionalizationChange)="updateFunctionalization($event)"
            />
          </div>
          @let functionalUsageWarning =
            clusterWarningsPlugin.selectors
              .getMessage(
                WarningCode.MissingFunctionalUsagesForSelectedAccounts
              )
              .asSignal();

          @if (functionalUsageWarning) {
            <atn-ds-notice
              [style]="DisplayStyle.Warning"
              [description]="functionalUsageWarning"
            />
          }
        </div>

        <div
          class="atn-space-cluster-functional-usage-modal__footer"
          footer
        >
          <atn-ds-button
            type="transparent"
            (click)="cancelClickHandler()"
            >Cancel</atn-ds-button
          >
          <atn-ds-button
            [disabled]="!canSave"
            [loading]="isLoading"
            (click)="saveClickHandler()"
            >Save</atn-ds-button
          >
        </div>
      </atn-ds-widget>
    </div>
  </atn-ds-centered-overlay>
}
